<nav class="breadcrumb-bar">
  <a [routerLink]="URL" class="breadcrumb-bar__link">
    <fa-icon icon="chevron-left"></fa-icon>
    {{ Title }}
  </a>
  <span class="breadcrumb-bar__divider"></span>
  <span>{{ PageName }}</span>
</nav>
